import { Routes } from '@angular/router';
import { RouteGuardService } from './services/auth/route-guard.service';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./views/pages/login/login.component').then(m => m.LoginComponent),
    data: {
      title: 'Login Page'
    }
  },
  {
    path: 'register',
    loadComponent: () => import('./views/pages/register/register.component').then(m => m.RegisterComponent),
    data: {
      title: 'Register Page'
    }
  },
  {
    path: '404',
    loadComponent: () => import('./views/pages/page404/page404.component').then(m => m.Page404Component),
    data: {
      title: 'Page 404'
    }
  },
  {
    path: '500',
    loadComponent: () => import('./views/pages/page500/page500.component').then(m => m.Page500Component),
    data: {
      title: 'Page 500'
    }
  },
  {
    path: '',
    canMatch: [RouteGuardService],
    canActivateChild: [RouteGuardService],
    loadComponent: () => import('./layout/default-layout/default-layout.component').then(m => m.DefaultLayoutComponent),
    data: {
      title: 'Home'
    },
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./views/start/routes').then(m => m.routes)
      },
      {
        path: 'notifications',
        loadChildren: () => import('./views/notifications/routes').then(m => m.routes)
      },
      {
        path: 'assets/it',
        loadChildren: () => import('./views/assets/routes').then(m => m.routes)
      },
      {
        path: 'assets/config',
        loadChildren: () => import('./views/assets/config/routes').then(m => m.routes)
      },
      {
        path: 'documents',
        loadChildren: () => import('./views/documents/routes').then(m => m.routes)
      },
      {
        path: 'chat',
        loadChildren: () => import('./views/chat/routes').then(m => m.routes)
      },
      {
        path: 'user-management',
        loadChildren: () => import('./views/user-management/routes').then(m => m.routes)
      },
      {
        path: 'employees',
        loadChildren: () => import('./views/hhrr/employees/routes').then(m => m.routes)
      },
      {
        path: 'reports/collections',
        loadChildren: () => import('./views/reports/collections/routes').then(m => m.routes)
      },
      {
        path: 'leads',
        loadChildren: () => import('./views/leads/routes').then(m => m.routes)
      },
      {
        path: 'events',
        loadChildren: () => import('./views/events/routes').then(m => m.routes)
      },
      {
        path: 'memorial-plaques',
        loadChildren: () => import('./views/memorial-plaques/routes').then(m => m.routes)
      },
      {
        path: 'accounting',
        loadChildren: () => import('./views/accounting/routes').then(m => m.routes)
      },
      {
        path: 'sales',
        loadChildren: () => import('./views/sales/routes').then(m => m.routes)
      },
      {
        path: 'collections',
        loadChildren: () => import('./views/collections/routes').then(m => m.routes)
      },
      {
        path: 'logistics',
        loadChildren: () => import('./views/logistics/routes').then(m => m.routes)
      },
      {
        path: 'training',
        loadChildren: () => import('./views/training/routes').then(m => m.routes)
      },
      {
        path: 'management',
        loadChildren: () => import('./views/management/routes').then(m => m.routes)
      }
    ]
  },
  { path: '**', redirectTo: 'login' }
];
